/* eslint-disable max-len */

/**
 * @author: Matthew Rawson @ 27/09/2017 12:14
 * @description: Custom simple heart Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react"
import BaseSvgIcon from "./Base"

const SimpleHeart = (props) => {
  return (
    <BaseSvgIcon {...props}>
      <path d="M14,2c2.8,0,5.1,2.3,5.1,5.1c0,1.1-0.2,2.2-1.1,3.2c0,0,0,0-0.1,0.1c0,0-1.5,1.5-3.7,3.8 C11.4,17,11.4,17,10.5,18c-0.1,0.1-0.3,0.2-0.4,0.2H9.9c-0.1,0-0.2-0.1-0.3-0.2l-7.1-7.1C1.5,9.7,1,8.5,1,7.1C1,4.3,3.3,2,6.1,2 c1.6,0,3,0.7,4,1.9C11,2.7,12.5,2,14,2z M10.1,16.7c0.7-0.7,1-1,3.4-3.5c2.4-2.4,3.7-3.7,3.7-3.8C17.8,8.7,18,7.9,18,7 c0-2.2-1.8-4-4-4c-1.5,0-2.8,0.8-3.5,2c0,0-0.1,0.3-0.4,0.3C9.7,5.3,9.6,5,9.6,5c-0.7-1.2-2-2-3.5-2c-2.2,0-4,1.8-4,4 c0,1.1,0.4,2.1,1.1,2.8l0,0L10.1,16.7z" />
    </BaseSvgIcon>
  )
}

export default SimpleHeart
